import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as styles from './AuthProgress.css';

type AuthProgressProps = {
  currentStep: number;
  totalSteps: number;
  showBack?: boolean;
  onBack?: () => void;
  backLabel?: string;
};

const clampStep = (step: number, totalSteps: number): number => {
  if (totalSteps <= 0) {
    return 0;
  }

  if (step <= 1) {
    return 1;
  }

  if (step > totalSteps) {
    return totalSteps;
  }

  return step;
};

export const AuthProgress = ({
  currentStep,
  totalSteps,
  showBack = false,
  onBack,
  backLabel = 'Back',
}: AuthProgressProps) => {
  const safeTotalSteps = Math.max(0, totalSteps);
  const safeStep = clampStep(currentStep, totalSteps);
  const percentage =
    safeTotalSteps === 0 ? 0 : (safeStep / safeTotalSteps) * 100;

  return (
    <div className={styles.root}>
      {showBack ? (
        <button
          type="button"
          className={styles.backButton}
          onClick={onBack}
          disabled={!onBack}
        >
          <FontAwesomeIcon icon={faArrowLeft} className={styles.backIcon} />
          <span>{backLabel}</span>
        </button>
      ) : null}

      <div
        className={styles.track}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={safeTotalSteps}
        aria-valuenow={safeStep}
        data-testid="auth-progress-track"
      >
        <div
          className={styles.fill}
          style={{ width: `${percentage}%` }}
          data-testid="auth-progress-fill"
        />
      </div>
    </div>
  );
};
